import { FilterOptionValueType, IFilter } from '../../interfaces/Filter.interfaces';

interface IChangeFilterOptionValueParams {
  currentFilters: IFilter[];
  targetFilter: IFilter;
  newOptionValues: FilterOptionValueType[];
}

export const changeFilterOptionValue = ({
  currentFilters,
  targetFilter,
  newOptionValues,
}: IChangeFilterOptionValueParams): IFilter[] => {
  const newProductFilters = currentFilters.map((filter) => {
    if (filter.key === targetFilter.key) {
      const newOptions = filter.options.map((option, index) => {
        option.value = newOptionValues[index];
        return option;
      });

      return { ...filter, options: newOptions };
    }

    return filter;
  });

  return newProductFilters;
};
